/**
 * @description 
 * Converts hexadecimal color code to RGB color code
 * 
 * Also works with shorthand hexadecimal code (i.e. #03f)
 * 
 * @param {any} color must be hex code (type is set to any as VSCode Intellisense doesn't recognize array methods on strings)
 * @param {string} opacity
 * @returns {string} RGBA color code
 */
export const convertHexToRgba = (color, opacity) => {
    let parsedColor = color.replace('#', '');
    parsedColor = parsedColor.match(new RegExp('(.{' + parsedColor.length/3 + '})', 'g'));

    // checks for shorthand hex code and converts to regular hex
    for (let i = 0; i < parsedColor.length; i++) {
        parsedColor[i] = parseInt(parsedColor.length % 2 ? parsedColor[i] + parsedColor[i] : parsedColor[i], 16);
    }

    const parsedOpacity = parseInt(opacity) / 100;
    parsedColor.push(parsedOpacity);

    return `rgba(${parsedColor.join(',')})`;
}